module.exports = __webpack_public_path__ + "static/side-projects-f40e33505d876becb88166447c8dc0c9.svg";